import { Platform } from '@angular/cdk/platform';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { COMPOSITION_BUFFER_MODE, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
    MAT_RIPPLE_GLOBAL_OPTIONS,
    MatNativeDateModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as Sentry from '@sentry/angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DateRangePickerOverview } from './core/picker/date-picker.component';
import { LinkifyPipe } from './core/pipe/linkify.pipe';
import { CustomDateAdapter, customDateFormats } from './core/util/custom-date-adapter';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { MonshinPageComponent } from './pages/monshin-page/monshin-page.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TooltipDirective } from './pages/tooltip/tooltip.directive';
import { LaunchDarklyService } from './services/launch-darkly.service';

@NgModule({
    declarations: [
        AppComponent,
        MonshinPageComponent,
        MaintenanceComponent,
        PrivacyPolicyComponent,
        TooltipDirective,
        DateRangePickerOverview,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        TooltipDirective,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        ToastrModule.forRoot(),
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatFormFieldModule,
        LinkifyPipe,
    ],
    providers: [
        LaunchDarklyService,
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({}),
        },
        { provide: MAT_DATE_LOCALE, useValue: 'ja-JP' },
        { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE, Platform] },
        { provide: MAT_DATE_FORMATS, useValue: customDateFormats },
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
        // Angular Forms で IME 変換確定前の文字列を参照する
        // iPad で IME 変換確定前に「次へ」を押した場合に入力値が欠落する現象が起きており、それを抑制するために COMPOSITION_BUFFER_MODE を追加した
        // COMPOSITION_BUFFER_MODE が未設定の場合 Android なら true, それ以外は false になるので iPad の場合は挙動が変わらないはずだが、実際には変化した
        // JIRA Bug: https://kakehashi.atlassian.net/browse/KAN-13824
        // Ref:
        // - https://qiita.com/rch850/items/f83f591b024f03c25668
        // - https://github.com/angular/angular/pull/15256
        { provide: COMPOSITION_BUFFER_MODE, useValue: false },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
